  <template>
  <div class="dem-edi-anexos">
    <div class="item-titulo">
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>
      Anexos
    </div>

    <div class="item-conteudo">
      <!-- SETA O STATUS DE CARREGANDO DA PAGINA -->
      <RF-Status v-if="statusGeral !== ''" :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>

      <!-- SETA OS DADOS DA TELA -->
      <template v-else>
        <div>
          <table>
            <tr>
              <template v-if="[ '', null, undefined ].indexOf(input) === -1 && Object.keys(input).length >= 1">
                <td class="adicionar">
                  <RF-Button :data-time='time' style="width: 142px;"
                    :cpntStatus='input.status' 
                    :cpntId='input.id' 
                    :cpntTipo='input.tipo' 
                    :cpntIcone='input.icone' 
                    :cpntTexto='input.texto' 
                    :cpntClass='input.class'
                    :cpntMostrar='input.mostrar'
                    :cpntTabIndex='input.tabIndex'
                    @onClickButton='input.onClick'
                  ></RF-Button>
                </td>
              </template>

              <template v-if="[ '', null, undefined ].indexOf(files) === -1 && files.length >= 1">
                <td class="files">
                  <template v-for="arquivo in files">
                    <Armazenamento-Arquivos-Icone :key="'div-' + arquivo.id"
                      :cpntId='arquivo.id'
                      :cpntFileName='arquivo.filename'
                      :cpntFileExt='arquivo.ext'
                      :cpntFileSizeThumbnail='arquivo.size_bytes_thumbnail'
                      :cpntThumbnail='arquivo.icone'

                      :cpntDeleteArquivo="venEditarAnexoRemoverArquivo"
                    ></Armazenamento-Arquivos-Icone>
                  </template>
                </td>
              </template>
            </tr>
          </table>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped>
.dem-edi-anexos {
  margin-top: 10px;
}
  .dem-edi-anexos > div > div {
    width: 100% !important;
    margin-top: -15px;
    background: none !important;
    text-align: left !important;
    border: none !important;
    box-shadow: none !important;
    margin-top: 10px !important;
  }
    .dem-edi-anexos > div > div > table {
      width: 100%;
      border-collapse: separate;
    }
      .dem-edi-anexos > div > div > table > tr > td.adicionar {
        width: 150px;
        text-align: left;
      }
        .dem-edi-anexos > div > div > table > tr > td.adicionar > label {
          border-radius: 20px;
          padding: 5px 15px;
          cursor: pointer;
          color: #0f3c4b;
          font-size: var(--font-base-soma-14);
        }
          .dem-edi-anexos > div > div > table > tr > td.adicionar > label > svg {
            margin-right: 4px;
          }
        .dem-edi-anexos > div > div > table > tr > td.adicionar > input {
          width: 0.1px;
          height: 0.1px;
          opacity: 0;
          overflow: hidden;
          position: absolute;
          z-index: -1;
        }
</style>

<style>
</style>

<script>
  export default {
    components: {
      'Armazenamento-Arquivos-Icone': () => import('@/components/armazenamento-arquivos/Armazenamento-Arquivos-Icone.vue'),
      'Armazenamento-Arquivos-Anexar': () => import('@/components/armazenamento-arquivos/anexar/Armazenamento-Arquivos-Anexar.vue'),
      'RF-Status-2': () => import('@/components/rf-geral/status/RF-Status-2.vue')
    },
    props: {
      cpntDemanda: {
        required: true,
        type: String
      },
      cpntDemandaId: {
        required: true,
        type: [ String, Number ]
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        input: {},
        files: []
      }
    },
    mounted: function () {
      // SETA O STATUS DA PAGINA
      this.venEditarAnexoSetarStatusGeral('carregando')
      
      // CHAMA A FUNÇÃO PARA INICIAR O APLICATIVO
      this.venEditarAnexoIniciar()
    },
    destroyed: function () {
      this.$store.state.WEB_SOCKET_OBSERVADOR('ArmArquivo', 'venda-anexos', null)
    },
    methods: {
      venEditarAnexoIniciar: function () {        
        // LIMPA OS ARQUIVOS EXISTENTES
        this.files = []

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // ADICIONA O OBSERVADOR
        this.$store.state.WEB_SOCKET_OBSERVADOR('ArmArquivo', 'venda-anexos', (evento) => {
          // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
          const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

          // PEGA A CHAVE REFERENCIA
          var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

          // ADICIONA O ARQUIVO RECEBIDO
          for (var indexF in evento) {
            if (evento[indexF][chaveD] === this.cpntDemandaId) {
              switch (evento[indexF].status) {
                case '1':
                  // INICIA A VARAIVEL INCONE
                  evento[indexF].icone = ''
      
                  // VERIFICA SE RECEBEU ALGUM THUMBNAIL
                  if ([ '', null, undefined ].indexOf(evento[indexF].thumbnail_b64) === -1) {
                    evento[indexF].icone = evento[indexF].thumbnail_b64
                  }

                  // INICIA O VALOR SE ELE NÃO EXISTIR
                  if ([ '', null, undefined ].indexOf(evento[indexF].size_bytes_thumbnail) !== -1) {
                    evento[indexF].size_bytes_thumbnail = 0
                  }
      
                  // ADICIONA O ARQUIVO
                  this.files.push(evento[indexF])
                  break

                default:
                  this.files = this.files.filter(item => item.id !== evento[indexF].id)
                  break
              }
            }
          }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }, 'usu')

        // IMPORTA A FUNÇÃO PARA ATUAIZAR OS DADOS DA API
        const FUN_TRATAR_RETONOS_E_CALLBACK = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_RETONOS_E_CALLBACK

        // EXECUTA A FUNÇÃO DE CALLBACKS
        FUN_TRATAR_RETONOS_E_CALLBACK(this, {
          venEditarAnexoBuscarArquivos: [ ],
          venEditarAnexoCriarNovo: [ ],
          venEditarAnexoFinalizar: [ 'venEditarAnexoBuscarArquivos', 'venEditarAnexoCriarNovo' ]
        },
        {
          venEditarAnexoBuscarArquivos: (chave, callback) => { this.venEditarAnexoBuscarArquivos(() => { callback(chave) } ) },
          venEditarAnexoCriarNovo: (chave, callback) => { this.venEditarAnexoCriarNovo(() => { callback(chave) } ) },
          venEditarAnexoFinalizar: (chave, callback) => { this.venEditarAnexoFinalizar(() => { callback(chave) } ) },
        })
      },
      venEditarAnexoSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      venEditarAnexoBuscarArquivos: function (callback = null, ids = []) {
        // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
        const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

        // PEGA A CHAVE REFERENCIA
        var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)
        
        // INICIA O QUERYGET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, filename: null, ext: null, size_bytes_thumbnail: null, last_at: null }, order: {} }

        // SETA O WHERE
        queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: chaveD, o: '=', v: this.cpntDemandaId } ] }

        // BUSCA APENAS OS ARQUIVOS SOLICITADOS
        if (ids.length >= 1) {
          queryGet.where.aAnd.push({ f: 'id', o: 'in', v: ids.join() })
        }

        // PEGA APENAS ARQUIVOS QUE NÃO SÃO INTERNOS
        queryGet.where.aAnd.push({ f: 'interno', o: '=', v: 'n' })

        // SETA A ORDENAÇÃO
        queryGet.order.last_at = 'asc'

        // FAZ A BUSCA NA API
        this.$store.state.comunicaAPI('/arm-arquivo/get/', 'GET', queryGet, (apiSuccess) => {
          // PEGA OS DADOS RECEBIDOS
          var vetor = apiSuccess.data

          // INICIA O VETOR QUE VAI RECEBER OS DADOS
          var thumbnailIds = []
          
          for (var key in vetor) {
            // VERIFICA SE TEM ICONE
            if ([ '', null, undefined ].indexOf(vetor[key].size_bytes_thumbnail) === -1 && Number(vetor[key].size_bytes_thumbnail) > 0) {
              thumbnailIds.push(vetor[key].id)
            }

            // INICIA A VARIAVEL QUE VAI RECEBER O ICONE
            vetor[key].icone = ''
          }

          // ADICIONA OS ARQUIVOS RECEBIDOS
          this.files = this.files.concat(vetor)

          // CHAMA A FUNÇÃO PARA BUSCAR OS ICONES
          this.venEditarAnexoBuscarThumbnail('thumbnail_b64', thumbnailIds, (registros) => {
            for (var key in registros) {
              // PEGA O NUMERO DA LINHA
              var index = this.files.findIndex(item => item.id === registros[key].id)

              // VERIFICA SE FOI ENCONTADO O ICONE
              if (index !== -1) {
                // SETA O ICONE
                this.files[index].icone = registros[key].thumbnail_b64
              }
            }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })

          // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
          if (callback !== null) {
            callback()
          }
        }, this.venEditarAnexoSetarStatusGeral)
      },
      venEditarAnexoBuscarThumbnail: function (tipo, ids, callback, qtde = 300, ini = null, fim = null, retornos = []) {
        // SETA OS DADOS QUE SERÁ BUSCADO
        if (ini === null && fim === null) {
          ini = 0
          fim = qtde
        } else if (ids.length > (ini + qtde)) {
          ini += qtde
          fim += qtde
        } else {
          ini = null
          fim = null
        }

        if (ini !== null && fim !== null) {
          // PEGA OS IDS QUE DEVE BUSCAR
          var busca = ids.slice(ini, fim)

          // INICIA O QUERYGET
          var queryGet = { lot: [] }
          
          // ADICIONA O VALOR AO VETOR
          for (var key in busca) {
            queryGet.lot.push({ id: busca[key], tipo: [ tipo ] })
          }

          // FAZ A BUSCA NA API
          this.$store.state.comunicaAPI('/arm-arquivo/arquivo/get/', 'GET', queryGet, (apiSuccess) => {
            // ADICIONA OS VALORES NO VETOR
            for (var index in apiSuccess.lot) {
              switch (apiSuccess.lot[index].code) {
                case '200':
                  retornos.push(apiSuccess.lot[index].data)
                  break

                default:
                  this.$store.state.msgWarn('API [' + apiSuccess.lot[index].code + ']: ' + apiSuccess.lot[index].message, 'danger')
                  break
              }
            }

            // FAZ A QUEBRA O VALOR RECEBIDO E CHAMA A FUNÇÃO PARA BUSCAR
            this.venEditarAnexoBuscarThumbnail(tipo, ids, callback, qtde, ini, fim, retornos)
          }, this.venEditarAnexoSetarStatusGeral)
        } else if (callback !== null) {
          callback(retornos)
        }
      },
      venEditarAnexoMontarRefMod: function () {
        switch (this.cpntDemanda) {
          case 'compra':
            return 11

          case 'venda':
            return 10
        }
      },
      venEditarAnexoCriarNovo: function (callback = null) {
        // SETA OS DADOS DO BUTTON
        this.input = {
          id: 'ven-editar-anexo-novo',
          status: '',
          tabIndex: 17070001,
          texto: 'Anexar arquivo',
          icone: { id: 'ven-editar-anexo-novo-icone', tipo: 'fas fa-plus' },
          value: '',
          disabled: false,
          tipo: 'icone-texto',
          class: [ 'btn', 'btn-default', 'btn-sm' ],
          anexar: false,
          onClick: () => {
            // SETA OS PARAMETROS PARA INICIAR
            var params = { tipo: 'ANEXAR_ARQUIVO', refMod: this.venEditarAnexoMontarRefMod(), refId: this.cpntDemandaId }
        
            // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
            this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // EXECUTA O CALLBACK RECEBIDO
        if (callback !== null) {
          callback()
        }
      },
      venEditarAnexoFinalizar: function (callback = null) {
        // SETA O STATUS DA PAGINA
        this.venEditarAnexoSetarStatusGeral('')

        // EXECUTA O CALLBACK RECEBIDO
        if (callback !== null) {
          callback()
        }
      },
      venEditarAnexoRemoverArquivo: function (id) {
        if (window.confirm('Deseja realmente enviar para a lixeira o arquivo selecionado?')) {
          // CRIA O FORMULARIO QUE SERÁ ENVIADO PARA API
          var formData = { j_id: [ id ] }

          // FAZ A COMUNICAÇÃO COM A API
          this.$store.state.comunicaAPI('/arm-arquivo/lixeira', 'DELETE', formData, (apiSuccess) => {
            // TRATA A MENSAGEM RECEBIDA
            this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

            if (apiSuccess.lot[0].code === '200') {
              // REMOVE O ID SOLICITADO
              this.files = this.files.filter(item => item.id !== id)

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            } else {
              // CHAMA A FUNÇÃO PARA INICIAR A TELA NOVAMENTE
              this.venEditarAnexoIniciar()
            }
          }, this.venEditarAnexoSetarStatusGeral)
        } else {
          this.venEditarAnexoIniciar()
        }
      }
    },
    watch: {
      cpntDemandaId: function () {
        this.venEditarAnexoIniciar()
      }
    }
  }
</script>
